const categoryList = [
    { value: "Endodontics", children: 
        [
            "Extirpation",
            "RCT (1 canal)",
            "RCT (multiple canals)",
            "Pulpotomy",
            "Pulpectomy",
            "Retrograde Root Filling",
            "Apicectomy"
        ] 
    },
    { value: "Implantology", children:
        [
            { value: "Anterior Implant", children:
                [
                    "Crown",
                    "Bridge",
                    "Removable"
                ]
            },
            { value: "Posterior Implant", children:
                [
                    "Bridge",
                    "Removable"
                ]
            },
            { value: "Bone Graft", children:
                [
                    "Autogenous Intraoral",
                    "Autogenous Extraoral",
                    "Xenograft",
                    "Allograft"                  
                ]
            },
            "Sinus Lift"
        ]
    },
    { value: "Maxillofacial surgery", children: 
        [
            "Trauma",
            "Orthognathic surgery",
            "Ortho-oral surgery",
            "Extra-Oral Implants",
            "Soft tissue surgery",
            "Oncology"
        ] 
    },
    { value: "Oral Medicine", children:
        [

        ]
    },
    { value: "Oral Surgery", children:
        [
            "Simple extraction(s)",
            "Surgical extraction (s) of 8s",
            "Surgical extraction (s) other",
            "Socket dressing",
            "Suturing",
            "Biopsy",
            "Cyst Enucleation",
            "Cyst Marsupialisation"
        ]
    },
    { value: "Orthodontics", children:
        [
            "Class I malocclusion",
            "Class II Division 1 malocclusion",
            "Class II Division 2 malocclusion",
            "Class III malocclusion"
        ]
    },
    { value: "Periodontology", children:
        [
            "OHI and Diet Advice",
            "Supragingival debridement",
            "Subgingival debridement",
            { value: "Gingival surgery", children:
                [
                    "Gingivectomy",
                    "Connective tissue graft",
                    "Free gingival graft"               
                ]
            },
            "Laser debridement"
        ]
    },
    { value: "Fixed Prosthodontics", children:
        [
            { value: "Crown", children:
                [
                    "MCC",
                    "PJC",
                    "FGC",
                    "ACC",
                    "SS PMC"
                ]
            },
            { value: "Conventional Bridge", children:
                [
                    "Ceramic",
                    "Metal Ceramic",
                    "Metal"
                ]
            },
            { value: "Inlay", children:
                [
                    "Composite",
                    "Ceramic",
                    "Metal Ceramic",
                    "Metal"
                ]
            },
            { value: "Onlay", children:
                [
                    "Composite",
                    "Ceramic",
                    "Metal Ceramic",
                    "Metal"
                ]
            },
            "Veneers"
        ]
    },
    { value: "Removable Prosthodontics", children:
        [
            { value: "Partial Denture", children:
                [
                    "Acrylic",
                    "CoCr",
                    "Other",
                ]
            },
            "Complete Denture",
            "Biteguard"
        ]
    },
    { value: "Restorative", children:
        [
            "Temporary filling",
            "Class I restoration",
            "Class II restoration",
            "Class III restoration",
            "Class IV restoration",
            "Class V restoration",
            "Class VI restoration",
            "Preventive Resin Restoration",
            "Fissure Sealant",
            "Fluoride application",
            "Intrinsic bleaching",
            "Extrinsic bleaching",
            "Core build up",
            "Direct post and core",
            "Indirect post and core",
            "Flexible splint",
            "Rigid splint",
            "Resin Infiltration",
            "Crown lengthening"
        ]
    },
    { value: "Laboratory", children:
        [
            "Study models",
            "Crowns",
            "Bridges",
            "Dentures",
            "Indirect post and core",
        ]
    },
    { value: "Dental Radiography (only)", children: [] }
]

export default categoryList;